import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SessionState } from 'src/app/core/constants/session.constants';

@Injectable({ providedIn: 'root' })
export class InactivityStateService {
  readonly state = signal<SessionState>('active');
  readonly state$ = toObservable(this.state);

  getValue(): SessionState {
    return this.state();
  }

  setState(state: SessionState): void {
    this.state.set(state);
  }
}
